<template>
    <div id="app" v-cloak>
        <HomePage></HomePage>
    </div>
</template>

<script>
import HomePage from '@/pages/home'

import queryString from 'query-string'

let parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    components: {
        HomePage,
    },
    data() {
        return {}
    },
    mounted() {
        this.init();
        if (parsed.clear) {
            localStorage.clear();
        }
    },
    methods: {
        init() {
            // 禁止双指放大
            document.documentElement.addEventListener(
                'touchstart',
                function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                },
                false
            )
            var lastTouchEnd = 0
            document.documentElement.addEventListener(
                'touchend',
                function (event) {
                    var now = Date.now()
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault()
                    }
                    lastTouchEnd = now
                },
                false
            )
        },
    }
}
</script>

<style lang="less">
[v-cloak] {
    display: none;
}
/*公共样式--开始*/
html,
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
input,
textarea,
select {
    margin: 0 !important;
    padding: 0;
}
* {
    box-sizing: border-box;
}
img {
    border: none;
    vertical-align: middle;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

a {
    text-decoration: none;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
}
input,
textarea {
    outline: none;
    border: none;
}
body {
    margin: 0;
    padding: 0;
    height: 100%;
}
#app {
    position: relative;
    min-height: 100vh;
    text-align: center;
    box-sizing: border-box;
    overflow: hidden; /* 防止内容溢出 */
}
</style>




// WEBPACK FOOTER //
// src/App.vue